import { render, staticRenderFns } from "./dicVitrine.vue?vue&type=template&id=fe65a20c&scoped=true"
import script from "./dicVitrine.vue?vue&type=script&lang=js"
export * from "./dicVitrine.vue?vue&type=script&lang=js"
import style0 from "./dicVitrine.vue?vue&type=style&index=0&id=fe65a20c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe65a20c",
  null
  
)

export default component.exports